$(function(){
    $('.iwish-seo-setting .seo-buttom span').on('click',function(){
        let t = $(this).text();
        if(t == 'Mehr anzeigen'){
            $('.iwish-seo-setting .seo-container').removeClass('max-height');
            $(this).html('Sich verstecken');
        }else{
            $('.iwish-seo-setting .seo-container').addClass('max-height');
            $(this).html('Mehr anzeigen');
        }
    });
});